export const statuses = {
  open: 'Registrada · sem lote',
  in_batch: 'Em lote',
  closed: 'Encerrada',
};

export const icons = {
  open: 'clock',
  in_batch: 'layer-group',
  closed: 'check-circle',
};

export function getName(value) {
  return statuses[value] || value;
}

export function getIcon(value) {
  return icons[value] || 'circle';
}

export function getLabel(value, batchNumber = null) {
  if (value === 'in_batch' && batchNumber) return `Lote nº ${batchNumber}`;
  if (value === 'closed' && batchNumber) return `Encerrada · Lote nº ${batchNumber}`;
  return getName(value);
}
